export default class GeneralComments {
    constructor(comments) {
        this.comments = comments;
    }
}